module.exports = __webpack_public_path__ + "img/logo.9eec646e.jpg";